module.exports = __webpack_public_path__ + "img/secretaria2.af22bc2f.png";